module.exports = __webpack_public_path__ + "img/first-section-2.2a0c4124.jpg";